export const INVALID_CREDENTIALS = 'The information you entered did not match our records. Try again.';
export const SECOND_FACTOR_INVALID = 'Authentication failed. Try again.';
export const INTERNAL_ERROR = 'An unexpected problem occurred. Contact your help desk for assistance.';
export const MODALITY_NOT_ALLOWED_OR_ENROLLED = 'There is a problem. Contact your help desk.';
export const USER_DISABLED = INVALID_CREDENTIALS;
export const USER_EXPIRED = INVALID_CREDENTIALS;
export const USER_LOCKED = INVALID_CREDENTIALS;
export const USERNAME_NOT_UNIQUE = INVALID_CREDENTIALS;
export const USER_NOT_FOUND = INVALID_CREDENTIALS;
export const INVALID_PHONE_NUMBER = 'Enter a 10-digit mobile phone number.';
export const INVALID_PHONE_VERIFICATION = 'That verification code isn\'t recognized. Try again.';
export const INVALID_IID_ENROLLMENT = 'The serial number and code aren\'t recognized. Try again.';
export const IID_SERIAL_NUMBER_IN_USE1 = 'This Imprivata ID serial number';
export const IID_SERIAL_NUMBER_IN_USE2 = 'is already in use.';
export const PUSH_REJECT = SECOND_FACTOR_INVALID;
export const INVALID_PASSWORD_RESET = 'Try again.';
export const APPLIANCE_NOT_CONNECTED = INTERNAL_ERROR;
export const SERVER_TIMEOUT = 'Session expired. Log in again.';
export const WORKFLOW_NOT_ALLOWED1 = 'Sorry. There is a problem. Contact your help desk.';
export const WORKFLOW_NOT_ALLOWED2 = 'No available authentication methods.';
export const WORKFLOW_NOT_ENABLED1 = 'Sorry. You are not enabled for signing. Contact your help desk.';
export const WORKFLOW_NOT_ENABLED2 = 'E-prescribe controlled substances not enabled.';
export const WORKFLOW_NOT_ASSIGNED1 = 'Sorry. There is a problem. Contact your help desk.';
export const WORKFLOW_NOT_ASSIGNED2 = 'Workflow not enabled.';

export const HELPDESK_VERIFICATION_RESULT_SUCCESS = 'Your identity has been verified.';
export const HELPDESK_VERIFICATION_DETAILS_SUCCESS = 'You may close this window.';
export const HELPDESK_VERIFICATION_RESULT_FAILED = 'We were unable to verify your identity.';
export const HELPDESK_VERIFICATION_DETAILS_FAILED = 'Contact your help desk for additional instructions.';
